import { Stack } from '../../design-system/stack/stack';
import { InvoicePayPageInnerWrapper } from './invoice-pay-page-inner-wrapper';

export const InvoicePayPageOuterWrapper = () => {
  return (
    <Stack align="stretch" className="min-h-screen py-2 pr-2">
      <Stack align="stretch" className="flex-1 overflow-clip rounded-md border border-border bg-background shadow-xs">
        <InvoicePayPageInnerWrapper />
      </Stack>
    </Stack>
  );
};
